import React, { useContext } from "react"
import { Grid, Header, Icon } from "semantic-ui-react"
import { BookerContext } from "~/contexts/BookerContext"
import Button from "../ui/Button"
import { darken } from 'polished'
import { getTextColorBasedOnBackground } from "./Prerequisites"

interface NoAvailableSitesProps {
  setShowDatesCard: (value: boolean) => void
  groupedReservationId: string | null
  setGroupedReservationId: (value: string | null) => void
}

const removeQueryParam = (param: string) => {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.delete(param)

  const url = new URL(window.location as unknown as string)
  url.search = urlParams.toString()

  window.history.pushState({}, "", url.toString())
}

const NoAvailableSites = ({
  setShowDatesCard,
  groupedReservationId,
  setGroupedReservationId,
}: NoAvailableSitesProps) => {
  
  const { secondaryColor } = useContext(BookerContext)

  return (
    <Grid.Column>
      <div className="p-8 text-center">
        <Header icon>
          <Icon name="calendar times outline" className="w-8 outline-0" />
          No Available Sites
        </Header>
        <p className="pb-4">
          There are no sites available for these dates that match your requirements. <br />
          Please adjust your date selection.
        </p>
        <Button
          children="Change Dates"
          className="font-bold"
          style={{
              background: secondaryColor,
              color: getTextColorBasedOnBackground(secondaryColor),
            }
          }
          onClick={() => {
            setShowDatesCard(true)
            if (groupedReservationId) {
              removeQueryParam("grouped_reservation")
              setGroupedReservationId(null)
            }
          }}
          hoverBg={darken(0.1, secondaryColor)}
        />
      </div>
    </Grid.Column>
  )
}

export default NoAvailableSites
